import React from "react";

const Group = ({ match }) => {
    console.log(match);
    return <div>회원그룹 편집 및 추가</div>;
};

export default Group;
